const marketColors = {
  colorMarketEm: '#009d98',
  gradientMarketEm: 'linear-gradient(85.85deg, var(--gradient-em-stop-1) 6.76%, var(--gradient-em-stop-2) 100.88%)',
};

export default marketColors;
